import { gql } from '@apollo/client';

export const EDIT_USER_META_MUTATION = gql`
  mutation editUserMeta($key: String!, $value: String!) {
    editUserMeta(key: $key, value: $value) {
      user {
        id
        meta {
          key
          value
        }
      }
    }
  }
`;
